<script lang="ts">
  import type { EventHours, EventHoursOccurrence } from "../../types";
  import AppBar from "../../components/app-bar.svelte";
  import EventsToday from "../../components/schedules/events-today.svelte";
  import AnnouncementsTable from "../../components/schedules/announcements-table.svelte";
  import Sprite from "../../components/sprite.svelte";
  import { onSchedule } from "../../domain/announcements";
  import { getNow, getTimeZone } from "../../data/clock";
  import { reify } from "../../domain/hours";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let data;

  $: announcements = onSchedule(data.announcements);
  $: settings = data.settings;
  $: places = data.places;
  $: events = data.events;

  $: occurrences = data.schedule.eventHours.flatMap(function (hours: EventHours) {
    return reify<EventHoursOccurrence>(hours, $time, 0, $timeZone);
  });

  $: showEventEndTime = settings.showEventEndTime == true;
</script>

<AppBar title="Today’s Schedule" />

<main>
  {#if occurrences.length == 0}
    <div class="Empty">
      <Sprite icon="icon-schedule" width={96} height={96} fill="rgba(0, 0, 0, 0.5)" />

      <p>No events scheduled</p>
    </div>
  {:else}
    <EventsToday entries={occurrences} {showEventEndTime} {places} {events} />
  {/if}

  {#if announcements.length > 0}
    <hr />
    <AnnouncementsTable {announcements} />
  {/if}
</main>

<style>
  main {
    flex: 1 1 auto;
    hyphens: auto;
    overflow: auto;
    padding-block: 8px;
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
    width: 100%;
  }

  .Empty {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px 48px 18px;
    justify-content: center;
    width: 100%;
  }

  .Empty p {
    margin: 1em 0 0;
  }

  hr {
    border-color: rgba(0, 0, 0, 0.25);
    margin: 20px 0 12px;
  }
</style>
